import { Component, Input, inject } from '@angular/core';
import { Router, ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { TitleService } from '../../services/title.service';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [RouterLink, RouterLinkActive]
})
export class BreadCrumbComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  breadcrumbService = inject(BreadcrumbService);
  titleService = inject(TitleService);

  @Input() breadcrumb: string; // not used?
  @Input() showTitle = true;

}
